// org-chart.service.ts
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { eps } from './url.service'
import { environment } from '../../environments/environment'

@Injectable({ providedIn: 'root' })
export class OrgChartService {
  private apiUrl = eps.company.officeApi
  constructor(private http: HttpClient) {}

  getOrgData(userId: string): Observable<any> {
    return this.http.get(
      `${environment.apiBaseUrl}/employee-manager/manager/${userId}/subordinates`
    )
  }

  // getOrgHierarchy(employeeId?: string): Observable<any> {
  //   return this.http.get(`${environment.apiBaseUrl}/employee-manager/root/${employeeId}`);
  // }

  getOrgHierarchy(userId?: string): Observable<any> {
  return userId
    ? this.http.get(`${environment.apiBaseUrl}/employee-manager/root/${userId}`)   // admin
    : this.http.get(`/api/org-hierarchy`)              // employee — full tree
}


  // Lazy loading - plus click hone par children fetch karo
  getChildren(employeeId: string): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/employee-manager/children/${employeeId}`);
  }
}

// org-chart.service.ts
// import { HttpClient } from '@angular/common/http'
// import { Injectable } from '@angular/core'
// import { Observable } from 'rxjs'
// import { eps } from './url.service'
// import { environment } from '../../environments/environment'

// @Injectable({ providedIn: 'root' })
// export class OrgChartService {
//   private apiUrl = eps.company.officeApi
//   constructor(private http: HttpClient) { }

//   getOrgData(userId: string): Observable<any> {
//     return this.http.get(
//       `${environment.apiBaseUrl}/employee-manager/manager/${userId}/subordinates`
//     )
//   }

//   // Returns the subtree rooted at the given employeeId.
//   // For admin → pass admin id → backend returns full org tree.
//   // For employee → returns subtree rooted at that employee only.
//   getOrgHierarchy(employeeId: string): Observable<any> {
//     return this.http.get(
//       `${environment.apiBaseUrl}/employee-manager/root/${employeeId}`
//     )
//   }

//   // Returns the manager/parent node for a given employee.
//   // This endpoint must return an object with at least { id, managerId }
//   // so we can do a second fetch with the manager's id.
//   //
//   // OPTION A — if your backend already has a "get my manager" endpoint:
//   //   Change the URL below to match your actual route.
//   //   Common patterns:  /employee-manager/manager/:userId
//   //                     /employees/:userId/manager
//   //                     /employee-manager/:userId/parent
//   //
//   // OPTION B — if no such endpoint exists yet, add this to your backend:
//   //   GET /employee-manager/manager/:userId
//   //   Returns: { id, firstName, lastName, picture, managerId, ... }
//   getEmployeeWithManager(userId: string): Observable<any> {
//     return this.http.get(
//       `${environment.apiBaseUrl}/employee-manager/manager/${userId}`
//     )
//   }


//   getFullOrgTree(): Observable<any> {
//     return this.http.get(
//       `${environment.apiBaseUrl}/employee-manager/root`
//     )
//   }

//   // Lazy load children when a node's expand button is clicked
//   getChildren(employeeId: string): Observable<any> {
//     return this.http.get(
//       `${environment.apiBaseUrl}/employee-manager/children/${employeeId}`
//     )
//   }
// }